import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'react-bootstrap';
import GallerySlider from '../components/GallerySlider';
import ProjectBreadcrumbs from '../components/ProjectBreadcrumbs';

function CircuitoCidade({ edicao, cidade }) {
  const programacaoPorDia = useMemo(() => {
    if (!cidade.programacao?.length) return [];
    const agrupado = [];
    cidade.programacao.forEach((item) => {
      const ultimo = agrupado.at(-1);
      if (ultimo && ultimo.dia === item.dia) {
        ultimo.itens.push(item);
      } else {
        agrupado.push({ dia: item.dia, itens: [item] });
      }
    });
    return agrupado;
  }, [cidade.programacao]);
  const totalAtividades = cidade.programacao?.length || 0;
  const totalDias = programacaoPorDia.length;

  return (
    <div className="circuit-page circuit-city-page">
      <section
        className="circuit-hero circuit-city-hero circuit-city-hero-bg"
        style={{ backgroundImage: `url(${cidade.imagem})` }}
      >
        <div className="circuit-city-hero-overlay" />
        <Container>
          <Row>
            <Col>
              <ProjectBreadcrumbs
                items={[
                  { label: 'Projetos', to: '/projetos' },
                  { label: 'Circuito Paulista de Hip Hop', to: '/projetos/circuito-paulista-hip-hop' },
                  {
                    label: `${edicao.ano}`,
                    to: '/projetos/circuito-paulista-hip-hop',
                    state: { scrollTargetId: `edicao-section-${edicao.slug}` }
                  },
                  { label: cidade.nome }
                ]}
              />
            </Col>
          </Row>
          <Row className="align-items-end g-4">
            <Col lg={8}>
              <div className="circuit-hero-copy">
                <span className="circuit-kicker">CIRCUITO PAULISTA DE HIP HOP</span>
                <h1>{cidade.nome}</h1>
                <p className="circuit-edition-summary">{cidade.resumo}</p>
                <div className="circuit-tags">
                  <span>Etapa {edicao.ano}</span>
                  <span>{edicao.titulo}</span>
                </div>
              </div>
            </Col>
            {totalAtividades > 0 && (
              <Col lg={4}>
                <div className="circuit-city-stats">
                  <div className="circuit-city-stat">
                    <strong>{totalDias}</strong>
                    <span>{totalDias === 1 ? 'dia' : 'dias'} de programação</span>
                  </div>
                  <div className="circuit-city-stat">
                    <strong>{totalAtividades}</strong>
                    <span>{totalAtividades === 1 ? 'atividade' : 'atividades'} realizadas</span>
                  </div>
                </div>
              </Col>
            )}
          </Row>
        </Container>
      </section>
      <section className="circuit-content-section">
        <Container>
          <Row className="g-4 align-items-start">
            <Col lg={8}>
              <div className="circuit-text-panel">
                {cidade.descricao.map((paragrafo) => (
                  <p key={paragrafo}>{paragrafo}</p>
                ))}
              </div>
            </Col>
            <Col lg={4}>
              <div className="circuit-side-stack">
                <div className="circuit-highlight-card">
                  <span className="circuit-highlight-label">Contexto da Edição</span>
                  <ul>
                    {edicao.destaques.map((destaque) => (
                      <li key={destaque}>{destaque}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {programacaoPorDia.length > 0 && (
        <section className="circuit-content-section">
          <Container>
            <div className="circuit-section-heading">
              <span className="circuit-kicker">Programação</span>
              <h2>Confira o que rolou</h2>
            </div>
            <Row className="g-4">
              {programacaoPorDia.map((grupo) => (
                <Col md={6} lg={4} key={grupo.dia}>
                  <div className="circuit-schedule-card">
                    <span className="circuit-schedule-day">{grupo.dia}</span>
                    <ul className="circuit-schedule-list">
                      {grupo.itens.map((item) => (
                        <li key={`${item.horario}-${item.descricao}`}>
                          <strong>{item.horario}</strong> {item.descricao}
                        </li>
                      ))}
                    </ul>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>
      )}

      {cidade.galeria?.length > 0 && (
        <section className="circuit-gallery-section">
          <Container>
            <div className="circuit-section-heading">
              <span className="circuit-kicker">Registros</span>
              <h2>Galeria de fotos</h2>
            </div>
            <GallerySlider images={cidade.galeria} />
          </Container>
        </section>
      )}
    </div>
  );
}

CircuitoCidade.propTypes = {
  edicao: PropTypes.shape({
    slug: PropTypes.string.isRequired,
    ano: PropTypes.string.isRequired,
    titulo: PropTypes.string.isRequired,
    destaques: PropTypes.arrayOf(PropTypes.string).isRequired
  }).isRequired,
  cidade: PropTypes.shape({
    slug: PropTypes.string.isRequired,
    nome: PropTypes.string.isRequired,
    imagem: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    resumo: PropTypes.string.isRequired,
    descricao: PropTypes.arrayOf(PropTypes.string).isRequired,
    programacao: PropTypes.arrayOf(PropTypes.shape({
      dia: PropTypes.string.isRequired,
      horario: PropTypes.string.isRequired,
      descricao: PropTypes.string.isRequired
    })),
    galeria: PropTypes.arrayOf(PropTypes.shape({
      src: PropTypes.string.isRequired,
      alt: PropTypes.string.isRequired
    }))
  }).isRequired
};

export default CircuitoCidade;